import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/auth/Login'
import ForgotPassword from '@/components/auth/ForgotPassword'
import Invoices from '@/components/Invoices'
import Invoice from '@/components/invoices/Invoice'
import Blacklist from '@/components/Blacklist'

import Dashboard from '@/components/Dashboard'
import Numbers from '@/components/Numbers'
import Subscriptions from '@/components/Subscriptions'
import SubscriptionOptions from '@/components/subscriptions/Options'
// import Bundles from '@/components/Bundles'
import BundlesOverview from '@/components/BundlesOverview'
import ExtraUserRequest from '@/components/bundles/ExtraUserRequest'
import ExtraNumberOverview from '@/components/bundles/ExtraNumberOverview'
import ExtraUserOverview from '@/components/bundles/ExtraUserOverview'
import ExtraNumberRequest from '@/components/bundles/ExtraNumberRequest'
import Account from '@/components/Account'
import Settings from '@/components/Settings'
import PasswordEdit from '@/components/PasswordEdit'
import EmailEdit from '@/components/EmailEdit'
import Usage from '@/components/Usage'
import Tickets from '@/components/Tickets'
import FeedbackCreate from '@/components/tickets/Create'
import Ticket from '@/components/tickets/Ticket'
import Credit from "../components/Credit.vue";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Login,
            beforeEnter: (to, from, next) => {

                window.ui.setViewTitle('');

                next();
            }
        },
        {
            path: '/forgot-password',
            component: ForgotPassword,
            beforeEnter: (to, from, next) => {

                window.ui.showBackButton('Login', 'Wachtwoord vergeten');

                next();
            }
        },
        {
            path: '/app',
            component: Dashboard,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    if(window.ui.getPlatform() === 'ios'){

                        window.ui.showBackButton(
                            'Terug',
                            'My Dubline',
                            {
                                ios: function(){

                                    window.location.href = 'close_webview';
                                }
                            }
                        );
                    }
                    else{

                        window.ui.setViewTitle('My Dubline');
                    }

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/numbers',
            component: Numbers,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Uitgaand nummer');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/subscriptions',
            component: Subscriptions,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Abonnement');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/subscription/:id/options',
            component: SubscriptionOptions,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Abonnement', 'Wijzigen');

                    //Allow route
                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/invoices',
            component: Invoices,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Facturen');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/blacklist',
            component: Blacklist,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Blokkades');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/invoice/:id',
            component: Invoice,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Facturen', 'Factuur ' + to.params.id);

                    //Allow route
                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/account',
            component: Account,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Persoonlijke gegevens');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/settings',
            component: Settings,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Configuratie');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/password-edit',
            component: PasswordEdit,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Wachtwoord wijzigen');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/email-edit',
            component: EmailEdit,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'E-mail wijzigen');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/usage',
            component: Usage,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Verbruik');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/feedback',
            component: Tickets,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Support');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/feedback/create',
            component: FeedbackCreate,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Support', 'Nieuw ticket');

                    //Allow route
                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            path: '/feedback/ticket/:id',
            component: Ticket,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Support', 'Ticket ' + to.params.id);

                    //Allow route
                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        // {
        //     name: 'account/bundles',
        //     path: '/account/:poc/bundles',
        //     component: Bundles,
        //     beforeEnter: (to, from, next) => {

        //         if(window.auth.isLoggedIn()){

        //             window.ui.showBackButton('My Dubline', 'Bundels');

        //             //Allow route

        //             next();
        //         }
        //         else{

        //             //Redirect to login

        //             next({path: window.auth.getLoginPath()});
        //         }
        //     }
        // },
        {
            name: 'account/bundles-overview',
            path: '/account/:poc/bundles-overview',
            component: BundlesOverview,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('My Dubline', 'Bundels');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            name: 'account/bundles-request/extra-user',
            path: '/account/:poc/bundles-request/extra-user/:subscriptionBundleId',
            component: ExtraUserRequest,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Bundels', 'Extra gebruiker');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            name: 'account/bundles-request/extra-number',
            path: '/account/:poc/bundles-request/extra-number?:numberType',
            component: ExtraNumberRequest,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Bundels', 'Extra nummer');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            name: 'account/bundles-request/extra-user-overview',
            path: '/account/:poc/bundles-request/extra-user-overview',
            component: ExtraUserOverview,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Bundels', 'Extra gebruiker(s) overzicht');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
        {
            name: 'account/bundles-request/extra-number-overview',
            path: '/account/:poc/bundles-request/extra-number-overview',
            component: ExtraNumberOverview,
            beforeEnter: (to, from, next) => {

                if(window.auth.isLoggedIn()){

                    window.ui.showBackButton('Bundels', 'Extra nummer(s) overzicht');

                    //Allow route

                    next();
                }
                else{

                    //Redirect to login

                    next({path: window.auth.getLoginPath()});
                }
            }
        },
      {
        path: '/credit',
        component: Credit,
        beforeEnter: (to, from, next) => {

          if(window.auth.isLoggedIn()){

            window.ui.showBackButton('My Dubline', 'Tegoed');

            //Allow route

            next();
          }
          else{

            //Redirect to login

            next({path: window.auth.getLoginPath()});
          }
        }
      },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js